__turbopack_context__.v({
  "className": "montserrat_48440e14-module__IwSV9G__className",
});
